import { defineTranslateKeys } from 'lib/tolgee'

const TOLGEE_KEYS = defineTranslateKeys({
  contextNameDescription: {
    key: 'errorNiches-contextNameDescription',
    defaultValue: 'Uma nova tentativa pode resolver, clique para recarregar os dados.',
  },

  contextName: {
    key: 'errorNiches-contextName',
    defaultValue: 'Oops! Parece que algo deu errado.',
  },
})

export default TOLGEE_KEYS
